import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Assets/css/style.css";

const AdminSidebar = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const menus = [
    { name: "Candidates", path: "/admin-candidates" },
    { name: "LeaderBoard", path: "/admin-leaderboard" },
    { name: "Create Question", path: "/admin-create" },
    { name: "Question List", path: "/admin-list" },
    { name: "Update Question", path: "/admin-update" },
    { name: "Delete Question", path: "/admin-delete" }
  ];

  return (
    <div className="sidebar">

      <h4 className="sidebar-title">Admin Panel</h4>

      {menus.map((menu, index) => (

        <div
          key={index}
          className={`sidebar-item ${
            location.pathname === menu.path ? "active" : ""
          }`}
          onClick={() => navigate(menu.path)}
        >
          {menu.name}
        </div>

      ))}

    </div>
  );
};

export default AdminSidebar;